import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { Danger } from 'iconsax-react';

const DevelopmentNote = () => {
  if(!process.env.NODE_ENV || process.env.NODE_ENV !== 'production') {
    return (
<Container>
  <Container center className={'fixed rounded-b-full w-full max-w-[448px] bg-gradient-to-b from-danger-500/70 from-40% z-[100000] block lg:hidden p-1 pt-0 -mb-4 right-[50%] translate-x-[50%]'}>
    <Danger size="12" className="text-white ml-1" />
    <Text className="text-white text-[10px] text-center">{localization.developmentNote}</Text>
  </Container>

  <div className='bg-danger-500 fixed left-[-40px] top-4 z-[9999] w-[150px] rotate-[-45deg] py-1 text-center font-bold text-white shadow-lg hidden lg:block'>
    DEV
  </div>
</Container>
    );
  } else return null
}
export default DevelopmentNote